import { createTheme } from "@material-ui/core";

// tasteck ブランドカラー (管理画面用、目に優しい調整版)
//
// 基本方針:
// - 8時間以上見続ける管理画面なので、明度・彩度を抑える
// - primary: ブランド teal だが「深め・静か」(0d9488 → 115e59)
// - secondary: coral は警告/危険アクション用にとっておく (#dc2626 寄り)
// - background は純白ではなく cool グレー (#f7f9fa) で目の負担を減らす
// - 文字 ink は維持
const theme = createTheme({
  palette: {
    primary: {
      light: "#0d9488", // 元 brand-teal-dark
      main: "#115e59", // 落ち着いた深い teal
      dark: "#0f4945", // さらに深い (押下/active 時)
      contrastText: "#ffffff",
    },
    secondary: {
      light: "#fca5a5", // 警告 hover
      main: "#dc2626", // 削除/アラートの赤 (元 coral から少し落ち着けた)
      dark: "#b91c1c",
      contrastText: "#ffffff",
    },
    error: {
      main: "#dc2626",
    },
    warning: {
      main: "#d97706",
    },
    success: {
      main: "#15803d",
    },
    info: {
      main: "#0d9488",
    },
    text: {
      primary: "#1a2332", // brand-ink
      secondary: "#5e6a7c",
    },
    background: {
      default: "#f3f5f7", // やや暗めの cool グレー
      paper: "#fbfcfd", // 純白から少し落としたカード色 (背景との階層感維持)
    },
    divider: "rgba(0, 0, 0, 0.08)",
  },

  typography: {
    htmlFontSize: 10,
    fontSize: 14,
    body1: {
      fontSize: "1.4rem",
    },
  },
  props: {
    MuiButtonBase: {
      disableRipple: true,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 479,
      md: 768,
      lg: 959,
      xl: 1112,
    },
  },
});

export default theme;
